<template>
  <div>
    <v-container>
      <v-toolbar flat color="white">
        <v-text-field
          v-model="search_str"
          label="搜索"
          clearable
          >
        </v-text-field>
        <v-btn @click="reload" small color="success" style="margin-left:10px;"><v-icon>search</v-icon>搜索</v-btn>
        <v-spacer></v-spacer>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-dialog v-model="dlgEdit" width="800px">
          <template v-slot:activator="{attrs, on}">
            <v-btn v-bind="attrs" v-on="on" small color="primary" dark class="mb-2" @click="addItem">添加釜票</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline">{{ dlgTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">客户</span>
                  </v-col>
                  <v-col cols="10">
                    <customer-sel ref="customerSel"></customer-sel>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">品名</span>
                  </v-col>
                  <v-col cols="10">
                    <v-text-field v-model="edItem.name" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">釜票编号</span>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="edItem.code" dense solo></v-text-field>
                  </v-col>
                  <v-col cols="2" class="fld">
                    <span class="flds">重量(kg)</span>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="edItem.weight" dense solo></v-text-field>
                  </v-col>
                  <v-col cols="2" class="fld">
                    <span class="flds">颜色</span>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="edItem.color" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">打包</span>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="edItem.pkg" dense solo></v-text-field>
                  </v-col>
                  <v-col cols="2" class="fld">
                    <span class="flds">打包规格</span>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="edItem.pkg_spec" dense solo></v-text-field>
                  </v-col>
                  <v-col cols="2" class="fld">
                    <span class="flds">生产时间(分钟)</span>
                  </v-col>
                  <v-col cols="2">
                    <v-text-field v-model="edItem.pd_time" dense solo></v-text-field>
                  </v-col>
                </v-row>
                <v-row class="row">
                  <v-col cols="2" class="fld">
                    <span class="flds">备注</span>
                  </v-col>
                  <v-col cols="10">
                    <v-text-field v-model="edItem.note" dense solo></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" small text @click="cancel">取消</v-btn>
              <v-btn color="primary" small @click="save">确定</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="formulas"
        :server-items-length="pagination.totalItems"
        :loading="loading"
        hide-default-footer
        class="elevation-1">
        <template v-slot:item.act="{item}">
          <v-btn small @click="editItem(item)" color="success"><v-icon>edit</v-icon>修改</v-btn>
          &nbsp;
          <v-btn small @click="deleItem(item)" color="error"><v-icon>delete</v-icon>删除</v-btn>
        </template>
        <template slot="no-data">
          没有数据
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pagination.totalPages"></v-pagination>
      </div>
    </v-container>
  </div>
</template>

<script>
import CustomerSel from '@/views/components/CustomerSel'
import { getFormulaList, addFormula, modifyFormula, deleteFormula } from '@/api/formula'
import { MsgError } from '@/libs/util';

export default {
  name: 'FormulaMng',
  components: {
    CustomerSel
  },
  data: () => ({
    search_str: '',
    dlgRight: false,
    dlgEdit: false,
    edID: 0,
    edItem: {
      customer_id: 0,
      name: '',
      code: '',
      weight: 0,
      color: '',
      pkg: '',
      pkg_spec: '',
      pd_time: 0,
      note: ''
    },
    headers: [
      { text: 'ID', value: 'id', sortable: false },
      { text: '客户', value: 'customer_title', sortable: false },
      { text: '品名', value: 'name', sortable: false },
      { text: '釜票编号', value: 'code', sortable: false },
      { text: '重量', value: 'weight', sortable: false },
      { text: '颜色', value: 'color', sortable: false },
      { text: '包装', value: 'pkg', sortable: false },
      { text: '包装规格', value: 'pkg_spec', sortable: false },
      { text: '生产时间', value: 'pd_time', sortable: false },
      { text: '备注', value: 'note', sortable: false },
      { text: '操作', value: 'act', sortable: false, width: 200 }
    ],
    formulas: [],
    pagination: {
      page: 0,
      sortBy: '',
      descending: false,
      rowsPerPage: 10,
      totalItems: 0,
      totalPages: 0
    },
    loading: false
  }),
  methods: {
    addItem () {
      this.edID = 0
      this.edItem.customer_id = 0
      this.edItem.customer_title = ''
      this.edItem.name = ''
      this.edItem.code = ''
      this.edItem.weight = 0
      this.edItem.color = ''
      this.edItem.pkg = ''
      this.edItem.pkg_spec = ''
      this.edItem.pd_time = ''
      this.edItem.note = ''
    },
    editItem (item) {
      this.dlgEdit = true
      this.edID = item.id
      this.edItem = Object.assign({}, item)
      this.$nextTick(() => {
        this.$refs.customerSel.setVal(item.customer_id, item.customer_title)
      })
    },
    doDele (id) {
      deleteFormula(id).then(res => {
        this.reload()
      })
    },
    deleItem (item) {
      this.$swal.fire({
        title: '警告',
        text: '确实要删除码?',
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then((result) => {
        if (result.isConfirmed) {
          this.doDele(item.id);
        }
      })
    },
    cancel () {
      this.dlgEdit = false
    },
    save () {
      if (this.edItem.name === undefined || this.edItem.name === '') {
        MsgError('品名不能为空')
        return
      }
      this.edItem.customer_id = this.$refs.customerSel.getVal()
      if (this.edID > 0) {
        modifyFormula(this.edID, this.edItem.customer_id, this.edItem.name,
          this.edItem.code, this.edItem.weight, this.edItem.color, this.edItem.pkg,
          this.edItem.pkg_spec, this.edItem.pd_time, this.edItem.note).then(res => {
          this.reload()
        }).catch(() => {
          this.dlgEdit = true
        })
      } else {
        addFormula(this.edItem.customer_id, this.edItem.name, this.edItem.code,
          this.edItem.weight, this.edItem.color, this.edItem.pkg,
          this.edItem.pkg_spec, this.edItem.pd_time, this.edItem.note).then(res => {
          this.reload()
        }).catch(() => {
          this.dlgEdit = true
        })
      }
      this.cancel()
    },
    reload () {
      let d = {
        'kw': this.search_str,
        'page': this.pagination.page,
        'perPage': this.pagination.rowsPerPage
      }
      this.loading = true
      getFormulaList(d).then(res => {
        this.loading = false
        this.formulas = res.data.items
        if (res.data._meta.page > res.data._meta.total_pages) {
          this.pagination.page = res.data._meta.total_pages
        } else {
          this.pagination.page = res.data._meta.page
        }
        this.pagination.totalPages = res.data._meta.total_pages
        this.pagination.totalItems = res.data._meta.total_items
      })
    }
  },
  computed: {
    dlgTitle () {
      return this.edID <= 0 ? '添加釜票' : '修改釜票'
    }
  },
  watch: {
    pagination: {
      handler () {
        this.reload()
      },
      deep: true
    }
  },
  mounted () {
    this.reload()
  }
}
</script>
